// extracted by mini-css-extract-plugin
export var bounce = "LogoCp-module--bounce--4eacd";
export var dotMoveLeft = "LogoCp-module--dot-move-left--aa941";
export var dotMoveRight = "LogoCp-module--dot-move-right--c311c";
export var gradient = "LogoCp-module--gradient--30eff";
export var image = "LogoCp-module--image--cf745";
export var link = "LogoCp-module--link--54ed6";
export var logo = "LogoCp-module--logo--970cf";
export var separatorWidth = "LogoCp-module--separator-width--3ed64";